<template>
    <AppNavigation>
        <mdb-container fluid>
            <h1 class="h1-responsive">Report Rider Performance</h1>
            <hr>
            <mdb-row>
                <mdb-col md="3">
                    <div class="form-group">
                        <mdb-date-picker :autoHide="true" v-model="date" label="Date" />
                    </div>
                </mdb-col>
                <mdb-col md="6">
                    <mdb-btn @click="getData()" v-if="!loading" outline="primary"><mdb-icon icon="search" /> Search</mdb-btn>
                    <mdb-spinner small v-if="loading" />
                </mdb-col>
            </mdb-row>
            <div v-if="loading">Wait.. Processing dont panic...</div>
            <mdb-tbl responsive striped v-if="!loading">
                <mdb-tbl-head>
                <tr>
                    <th width="5%">#</th>
                    <th>Name</th>
                    <th>Accept Job Count</th>
                    <th>Switch Job Count</th>
                    <th>Minutes Online Count</th>
                    <th>Date Time</th>
                </tr>
                </mdb-tbl-head>
                <mdb-tbl-body>
                <tr style="cursor: pointer" v-for="(record, index) in records" :key="record.id">
                    <td>{{index+1}}</td>
                    <td>{{record.user.name}}</td>
                    <td>{{record.count_accept_job}}</td>
                    <td>{{record.count_switch_job}}</td>
                    <td>{{record.count_duration_minutes}}</td>
                    <td>{{momentFormatDate16(record.created_at)}}</td>
                </tr>
                </mdb-tbl-body>
            </mdb-tbl>
        </mdb-container>
    </AppNavigation>
</template>

<script>
// @ is an alias to /src
import {mdbContainer,mdbTbl, mdbTblHead, mdbTblBody, mdbRow, mdbCol, mdbBtn, mdbDatePicker } from 'mdbvue';
import AppNavigation from '../components/AppNavigation';
import {ajax} from '../js/ajax';
import {momentFormatDate16} from '../js/helper';
// import {APP_FILE_URL} from '../js/config';

export default {
    name: 'report_partner_daily',
    components: {
        mdbContainer, mdbTbl, mdbTblHead, mdbTblBody,
        AppNavigation, mdbRow, mdbCol, mdbBtn, mdbDatePicker
    },
    data: ()=>({
        date: "",
        loading:false,
        records: []
    }),
    methods: {
        getData(){
            if(this.loading){
                return false;
            }
            this.loading=true;
            ajax({
                url: "admin/get_partner_daily_events",
                data: {
                    date: this.date
                },
                complete: ()=>this.loading=false,
                success: result=>{
                    this.records=result.data;
                },
            }, this)
        },
        momentFormatDate16(date){
          return momentFormatDate16(date);
        },
    },
    mounted: function(){
        let date = new Date();
        let month = date.getMonth()+1;
        this.date=date.getFullYear()+'-'+("0" + month).slice(-2)+'-'+("0" + date.getDate()).slice(-2);
        this.getData();
    }
}
</script>
